import { PaymentItemSchema, PaymentTypeSchema } from '@/schemas/payments.schema'
import { TransactionStatusSchema } from '@/schemas/transaction_status.schema'
import { z } from 'zod'
import { ServiceFeePayerSchema } from '../payments/service_fee.schema'

const ExpenseCategorySchema = z.object({
  id: z.number(),
  name: z.string(),
  amount: z.number(),
})

const PurseMovementSchema = z.object({
  id: z.number(),
  transaction_id: z.number(),
  purse_id: z.number(),
  total_amount: z.number(),
  name: z.string(),
  amount: z.number(),
  created_datetime: z.string(),
  student_name: z.string(),
  last_datetime: z.string(),
})

export const TransactionDetailsSchema = z.object({
  transaction_id: z.number(),
  payment_id: z.number(),
  status: TransactionStatusSchema,
  type: PaymentTypeSchema,
  service_fee_payer: ServiceFeePayerSchema,
  total_amount: z.number(),
  invoice_quote: z.string().nullable(),
  tracking_number: z.string().nullable(),
  service_fee: z.number(),
  payment_items: z.array(PaymentItemSchema),
  amount_provider: z.number(),
  transaction_type: z.string().nullable(),
  payment_documents: z.array(
    z.object({
      path: z.string(),
      student_id: z.number().optional(),
      student_name: z.string().optional(),
      invoice_number: z.string().optional(),
      invoice_date: z.string().optional(),
      amount: z.number().optional(),
      notes: z.string().optional(),
    })
  ),
  program_id: z.union([z.number(), z.null()]),
  scholarship_application_id: z.union([z.number(), z.null()]),
  last_message: z.string().nullable(),
  has_appealed: z.number().nullable(),
  student_name: z.undefined(),
  applicant_name: z.string(),
  provider_id: z.number().nullable(),
  students: z.array(
    z.object({
      student_name: z.string(),
    })
  ),
  provider_name: z.string().nullable(),
  created_datetime: z.string(),
  expense_categories: z.array(ExpenseCategorySchema),
  purse_movements: z.array(PurseMovementSchema).optional(),
})

export type TransactionDetails = z.infer<typeof TransactionDetailsSchema>
export type PurseMovement = z.infer<typeof PurseMovementSchema>
